import type { KeyValuePair as SharedKeyValuePair } from "../../lib/normalizeSectionInputs";

export type KeyValuePair = SharedKeyValuePair;
export type AcroFormValues = { [name: string]: string };

export function submitAcroForm(params: {
  saveClickedRef: React.MutableRefObject<boolean>;
  collectCurrentKeyValuePairs: () => KeyValuePair[];
  sectionPairs: { [sectionKey: string]: KeyValuePair[] };
  currentSectionIndex: number;
  // Optional: include full sectionInputs to ensure all sections are saved
  allSectionInputs?: { [sectionKey: string]: { [name: string]: string } };
  allPreviewValues?: Record<string, string>;
  mutate: (args: { payload: unknown; saveClicked: boolean }) => void;
}) {
  const {
    saveClickedRef,
    collectCurrentKeyValuePairs,
    sectionPairs,
    currentSectionIndex,
    allSectionInputs,
    allPreviewValues,
    mutate,
  } = params;

  saveClickedRef.current = true;
  const currentPairs = collectCurrentKeyValuePairs();
  const sectionKey = String(currentSectionIndex);

  const updatedSectionPairs = { ...sectionPairs, [sectionKey]: currentPairs };

  const fromSectionPairs: KeyValuePair[] = [];
  Object.values(updatedSectionPairs).forEach((sectionData) => {
    if (Array.isArray(sectionData)) {
      fromSectionPairs.push(...sectionData);
    }
  });

  const latestByKey = new Map<string, string | number | boolean>();
  fromSectionPairs.forEach((p) => latestByKey.set(p.key, p.value));
  currentPairs.forEach((p) => latestByKey.set(p.key, p.value));

  // Also merge values from allSectionInputs (prefill or unseen sections)
  // Prefill baseline values from all sections only when a key isn't present yet
  if (allSectionInputs) {
    Object.values(allSectionInputs).forEach((formVals) => {
      Object.entries(formVals).forEach(([key, val]) => {
        if (!latestByKey.has(key)) {
          latestByKey.set(key, val);
        }
      });
    });
  }
  if (allPreviewValues) {
    Object.entries(allPreviewValues).forEach(([key, val]) => {
      // Only set if not already present to keep latest user edits from DOM taking precedence
      if (!latestByKey.has(key)) {
        latestByKey.set(key, val);
      }
    });
  }

  // Send array of { key, value } pairs as requested
  const finalPairs: KeyValuePair[] = Array.from(latestByKey.entries()).map(([key, value]) => ({ key, value }));
  mutate({ payload: finalPairs, saveClicked: true });
}
